import React from "react";
import { Box } from "@mui/material";

export const CustomTabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ height: "100%", display: value === index ? "flex" : "none", flexDirection: "column" }}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0, height: "100%", display: "flex", flexDirection: "column" }}>
          {children}
        </Box>
      )}
    </div>
  );
};

export const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

